import React from 'react';
import { Accordion } from '../../../components';
import { formatControlValue } from '../../../helpers/Functions';

import { SnippetConfiguration, SnippetDataDictionary } from '../../../services/dataModels';
import { DataRow } from './DataRow';

interface TagSnippetProps {
  path: string;
  configuration: SnippetConfiguration;
  data: SnippetDataDictionary[];
}

const TagSnippet = ({ path, configuration, data }: TagSnippetProps) => {
  const titleControlType = configuration.columns.find(
    (c) => c.name === configuration.rowTitleKey,
  )?.controlType;
  return (
    <>
      {data.map((r, i) => (
        <Accordion
          key={i}
          size={configuration.columns.length}
          title={formatControlValue(titleControlType, r[configuration.rowTitleKey] as string)}>
          <DataRow
            path={`${path}.rowData[${i}]`}
            configuration={configuration.columns}
            data={r}
            disabled={Object.keys(r).filter((c) => c !== 'Comments')}
          />
        </Accordion>
      ))}
    </>
  );
};

export default TagSnippet;
